/* ================================================================================ */
/* ブランドフィルターを探しやすくする                                                */
/*                                                                                  */
/* 1. 頭文字（A〜Z・#）で絞り込むインデックスを検索欄の下に置く                      */
/* 2. 検索欄をカタカナでも引けるようにする                                           */
/*                                                                                  */
/* Boost の絞り込みは英字の vendor 名にしか当たらず、カタカナを入れると候補の li を   */
/* DOM ごと消してしまう。そこで検索欄の手前に自前の input を差し込んで仲介する。      */
/* 辞書は boost-filter-brand-kana.js（商品タグから機械生成）。                        */
/*                                                                                  */
/* Boost はフィルター操作やページ送りのたびにリストを差し替えるので、                */
/* MutationObserver で追従する。処理は冪等で、自分の書き換えで observer が            */
/* 再帰しても1回で収束する。                                                        */
/*                                                                                  */
/* 対象の見つけ方: PC 用と SP ドロワー用で DOM が二重に描画され、data 属性の有無も    */
/* 揃わないため（boost-filter-hierarchy.js と同じ事情）、属性ではなく                 */
/* 「検索欄を持つフィルター」という中身の形で判定する。                              */
/*                                                                                  */
/* カラーの市松アイコンと並び順は Boost 管理画面側で持たせているので、ここでは        */
/* 何もしない（Settings > Swatches > Tag に画像を登録済み。2026-09-01）。            */
/* ================================================================================ */

(function () {
  'use strict';

  var LIST_SELECTOR = '.boost-sd__filter-option-listitem';
  var ITEM_SELECTOR = '.boost-sd__filter-option-item';
  var LABEL_SELECTOR = '.boost-sd__filter-option-item-label';
  var SEARCH_INPUT_SELECTOR = '.boost-sd__filter-option-search-option';
  var PROXY_CLASS = 'rehello-filter-search-proxy';
  /* 自前の入力欄は見た目を合わせるため Boost と同じクラスを持つ。
     探すときに拾ってしまわないよう、除外したセレクタを使う */
  var NATIVE_SEARCH_SELECTOR = SEARCH_INPUT_SELECTOR + ':not(.' + PROXY_CLASS + ')';

  function textOf(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function labelOf(item) {
    return textOf(item.querySelector(LABEL_SELECTOR));
  }

  /* ------------------------------------------------------------------------------ */
  /* 辞書                                                                            */
  /* ------------------------------------------------------------------------------ */

  /* ここは boost-filter-brand-kana.js が読み込まれている時だけ動く。
     辞書（vendor 名 → カタカナ表記）は商品タグから生成している。
     読み込み順に依存しないよう、参照は毎回取り直す */
  function kanaDict() {
    return (window.RehelloBrandKana && window.RehelloBrandKana.dict) || null;
  }

  var KANA_ATTR = 'data-rehello-kana';
  var HIDDEN_CLASS = 'rehello-filter-item--kana-hidden';

  /* ひらがな→カタカナ・全角英数→半角・大小文字の差を吸収して比較用の文字列にする */
  function normalize(text) {
    return String(text)
      .replace(/[ぁ-ゖ]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) + 0x60);
      })
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
      })
      .replace(/[・･\sー\-]/g, '')
      .toUpperCase();
  }

  function hasKanaQuery(text) {
    return /[ぁ-ゖァ-ヺ一-龥]/.test(text);
  }

  /* 各値に「英字表記＋カタカナ表記」を突き合わせ用に持たせる。
     読みは画面には出さない。ブランド名が2行になると Boost の行組み
     （button が block・ラベルが inline・件数が block）が崩れて件数が下へ落ちるため、
     カタカナで引けることは検索欄のプレースホルダーで案内している */
  function annotate(item) {
    if (item.hasAttribute(KANA_ATTR)) return;
    var name = labelOf(item);
    var dict = kanaDict();
    var kana = (dict && dict[name]) || '';
    item.setAttribute(KANA_ATTR, normalize(name + kana));
  }

  /* 値の頭文字。記号や数字から始まるものは # にまとめる */
  function initialOf(name) {
    var head = String(name).replace(/^[^0-9A-Za-z]+/, '').charAt(0).toUpperCase();
    return head >= 'A' && head <= 'Z' ? head : '#';
  }

  var INITIAL_ATTR = 'data-rehello-initial';

  /* 各値に、突き合わせ用の「英字表記＋カタカナ表記」と頭文字を持たせる。
     読みは画面には出さない。ブランド名が2行になると Boost の行組み
     （button が block・ラベルが inline・件数が block）が崩れて件数が下へ落ちるため、
     カタカナで引けることは検索欄のプレースホルダーで案内している */
  function annotate(item) {
    if (item.hasAttribute(KANA_ATTR)) return;
    var name = labelOf(item);
    var dict = kanaDict();
    var kana = (dict && dict[name]) || '';
    item.setAttribute(KANA_ATTR, normalize(name + kana));
    item.setAttribute(INITIAL_ATTR, initialOf(name));
  }

  /* 表示する値を決める。Boost の絞り込みは英字にしか当たらず、カタカナを入れると
     候補の li を DOM ごと消してしまう（CSS では戻せない）。そこでカタカナのときは
     Boost 側の検索語を空にして全件を描かせ、絞り込みはこちらで行う。
     頭文字の絞り込みも同じ仕組みに乗せる */
  function applyFilters(option) {
    var list = option.querySelector(LIST_SELECTOR);
    if (!list) return;

    var proxy = option.querySelector('.' + PROXY_CLASS);
    var query = (proxy && proxy.value) || '';
    var initial = option.getAttribute(ACTIVE_INITIAL_ATTR) || '';
    var needle = hasKanaQuery(query) ? normalize(query) : '';

    var items = list.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      annotate(items[i]);
      var hit =
        (!needle || items[i].getAttribute(KANA_ATTR).indexOf(needle) !== -1) &&
        (!initial || items[i].getAttribute(INITIAL_ATTR) === initial);
      items[i].classList.toggle(HIDDEN_CLASS, !hit);
    }
  }

  var PROXIED_ATTR = 'data-rehello-proxied';
  var ACTIVE_INITIAL_ATTR = 'data-rehello-active-initial';
  var INDEX_CLASS = 'rehello-brand-index';
  var INDEX_BUTTON_CLASS = 'rehello-brand-index__letter';
  var INDEX_ACTIVE_CLASS = 'rehello-brand-index__letter--active';

  /* Boost の検索欄は React の管理下にある。値を差し替えるときは input.value に
     代入するだけでは state が追従しないので、prototype 側の setter を呼んでから
     input イベントを投げる（React が拾う経路に合わせる） */
  function setNativeValue(input, value) {
    if (input.value === value) return;
    var setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    );
    if (setter && setter.set) setter.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* 打ち込む先を自前の input にすげ替える。
     英字ならそのまま Boost に流し（件数の再計算まで Boost の実装が効く）、
     カタカナなら Boost には空を渡して全件を描かせ、表示だけこちらで絞る */
  function installSearchProxy(option) {
    var native = option.querySelector(NATIVE_SEARCH_SELECTOR);
    if (!native || native.hasAttribute(PROXIED_ATTR)) return;
    if (!option.querySelector(LIST_SELECTOR)) return;

    var proxy = document.createElement('input');
    proxy.type = 'text';
    proxy.autocomplete = 'off';
    proxy.className = native.className + ' ' + PROXY_CLASS;
    /* カタカナでも引けることは見ただけでは分からないので、入力欄で案内する */
    proxy.placeholder = kanaDict() ? 'ブランド名で探す（カタカナ可）' : native.placeholder;
    proxy.value = native.value;

    native.setAttribute(PROXIED_ATTR, '1');
    native.setAttribute('tabindex', '-1');
    native.setAttribute('aria-hidden', 'true');
    native.parentNode.insertBefore(proxy, native);

    proxy.addEventListener('input', function () {
      var query = proxy.value;
      /* 打ち込み始めたら頭文字の絞り込みは解除する（併用すると0件になりやすい） */
      if (query) selectInitial(option, '');
      setNativeValue(native, hasKanaQuery(query) ? '' : query);
      /* Boost が描き直したあとに当てたいので、observer 側の再描画に任せる。
         入力を止めた場合に取りこぼさないよう、ここでも一度当てておく */
      applyFilters(option);
    });
  }

  /* 頭文字の絞り込みを切り替える。同じ文字をもう一度押したら解除 */
  function selectInitial(option, letter) {
    var current = option.getAttribute(ACTIVE_INITIAL_ATTR) || '';
    var next = current === letter ? '' : letter;

    if (next) option.setAttribute(ACTIVE_INITIAL_ATTR, next);
    else option.removeAttribute(ACTIVE_INITIAL_ATTR);

    var buttons = option.querySelectorAll('.' + INDEX_BUTTON_CLASS);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle(
        INDEX_ACTIVE_CLASS,
        buttons[i].getAttribute('data-letter') === next
      );
    }
  }

  /* 検索欄の下に A〜Z・# のインデックスを置く。1,500 件を頭文字で辿れるようにする */
  function installIndexBar(option) {
    var proxy = option.querySelector('.' + PROXY_CLASS);
    if (!proxy || option.querySelector('.' + INDEX_CLASS)) return;

    var bar = document.createElement('div');
    bar.className = INDEX_CLASS;

    var letters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    for (var i = 0; i < letters.length; i++) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = INDEX_BUTTON_CLASS;
      button.setAttribute('data-letter', letters[i]);
      button.textContent = letters[i];
      bar.appendChild(button);
    }

    bar.addEventListener('click', function (event) {
      var button = event.target.closest('.' + INDEX_BUTTON_CLASS);
      if (!button) return;
      /* 頭文字で辿るときは打ち込んだ語を消す。Boost 側の検索語も戻す */
      proxy.value = '';
      var native = option.querySelector(NATIVE_SEARCH_SELECTOR);
      if (native) setNativeValue(native, '');
      selectInitial(option, button.getAttribute('data-letter'));
      applyFilters(option);
    });

    proxy.parentNode.insertBefore(bar, proxy.nextSibling);
  }

  /* ------------------------------------------------------------------------------ */
  /* 実行                                                                            */
  /* ------------------------------------------------------------------------------ */

  var pending = null;

  function renderAll() {
    if (!kanaDict()) return;

    var options = document.querySelectorAll('.boost-sd__filter-option');
    for (var j = 0; j < options.length; j++) {
      var option = options[j];
      if (!option.querySelector(NATIVE_SEARCH_SELECTOR)) continue;

      installSearchProxy(option);
      installIndexBar(option);

      /* Boost がリストを描き直すと絞り込みが外れるので、選択が残っていれば当て直す */
      var proxy = option.querySelector('.' + PROXY_CLASS);
      if ((proxy && proxy.value) || option.hasAttribute(ACTIVE_INITIAL_ATTR)) {
        applyFilters(option);
      }
    }
  }

  function scheduleRender() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      renderAll();
    }, 80);
  }

  function init() {
    scheduleRender();

    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(scheduleRender);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
